import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ReactComponent as GrasaVisceralImage } from "../../../../assets/metricas/Grasa_visceral_image.svg";
import { ReactComponent as AguaCorporalImage } from "../../../../assets/metricas/agua_corporal_image.svg";
import { ReactComponent as BmrImage } from "../../../../assets/metricas/bmr_image.svg";
import { ReactComponent as EdadCorporalImage } from "../../../../assets/metricas/edad_corporal_image.svg";
import { ReactComponent as GrasaCorporalImage } from "../../../../assets/metricas/grasa_corporal_image.svg";
import { ReactComponent as GrasaSubcutaneaImage } from "../../../../assets/metricas/grasa_subcutanea_image.svg";
import { ReactComponent as ImcImage } from "../../../../assets/metricas/imc_image.svg";
import { ReactComponent as MasaEsqueleticaImage } from "../../../../assets/metricas/masa_esqueletica_image.svg";
import { ReactComponent as MasaMuscularImage } from "../../../../assets/metricas/masa_muscular_image.svg";
import { ReactComponent as MusculoEsqueleticoImage } from "../../../../assets/metricas/musculo_esqueletico_image.svg";
import { ReactComponent as PesoImage } from "../../../../assets/metricas/peso_image.svg";
import { ReactComponent as ProteinaImage } from "../../../../assets/metricas/proteina_image.svg";
import { metricFormatAthlete } from "../../../../utils/utils";
const Step5 = ({ userDetail }) => {
  const info = userDetail?.personal_information;
  const log = userDetail?.body_data;

  const optionLogs = [
    {
      id: 1,
      name: `Peso`,
      nameComplete: "Peso",
      image: <PesoImage width="100%" />,
      value: log?.HEALTH_LOG_WEIGHT?.[0]?.log_numeric || "---",
      measure: 'Kg',
      scale:
        metricFormatAthlete(
          1,
          log?.HEALTH_LOG_WEIGHT?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 2,
      name: `IMC`,
      nameComplete: "IMC",
      image: <ImcImage width="100%" />,
      value: log?.HEALTH_LOG_IMC?.[0]?.log_numeric || "---",
      scale:
        metricFormatAthlete(
          2,
          log?.HEALTH_LOG_IMC?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 3,
      name: `Grasa corporal`,
      nameComplete: "Grasa corporal",
      image: <GrasaCorporalImage width="100%" />,
      value: log?.HEALTH_LOG_BODY_FAT?.[0]?.log_numeric || "---",
      measure: '%',
      scale:
        metricFormatAthlete(
          3,
          log?.HEALTH_LOG_BODY_FAT?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 5,
      name: `Grasa subcutánea`,
      nameComplete: "Grasa subcutánea",
      image: <GrasaSubcutaneaImage width="100%" />,
      value: log?.HEALTH_LOG_UNDERSKIN_FAT?.[0]?.log_numeric || "---",
      measure: '%',
      scale:
        metricFormatAthlete(
          5,
          log?.HEALTH_LOG_UNDERSKIN_FAT?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 6,
      name: `Grasa visceral`,
      nameComplete: "Grasa visceral",
      image: <GrasaVisceralImage width="100%" />,
      value: log?.HEALTH_LOG_VISCERAL_FAT?.[0]?.log_numeric || "---",
      scale:
        metricFormatAthlete(
          6,
          log?.HEALTH_LOG_VISCERAL_FAT?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 7,
      name: `Agua corporal`,
      nameComplete: "Agua corporal",
      image: <AguaCorporalImage width="100%" />,
      value: log?.HEALTH_LOG_CORPORAL_WATER?.[0]?.log_numeric || "---",
      measure: '%',
      scale:
        metricFormatAthlete(
          7,
          log?.HEALTH_LOG_CORPORAL_WATER?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 8,
      name: `Músculo esquelético`,
      nameComplete: "Músculo esquelético",
      image: <MusculoEsqueleticoImage width="100%" />,
      value: log?.HEALTH_LOG_BONE_MUSCLE?.[0]?.log_numeric || "---",
      measure: '%',
      scale:
        metricFormatAthlete(
          8,
          log?.HEALTH_LOG_BONE_MUSCLE?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 10,
      name: `Masa muscular`,
      nameComplete: "Masa muscular",
      image: <MasaMuscularImage width="100%" />,
      value: log?.HEALTH_LOG_MUSCLE_MASS?.[0]?.log_numeric || "---",
      measure: 'Kg',
      scale:
        metricFormatAthlete(
          10,
          log?.HEALTH_LOG_MUSCLE_MASS?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 9,
      name: `Masa esquelética`,
      nameComplete: "Masa esquelética",
      image: <MasaEsqueleticaImage width="100%" />,
      value: log?.HEALTH_LOG_BONE_MASS?.[0]?.log_numeric || "---",
      measure: 'Kg',
      scale:
        metricFormatAthlete(
          9,
          log?.HEALTH_LOG_BONE_MASS?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 11,
      name: `Proteína`,
      nameComplete: "Proteína",
      image: <ProteinaImage width="100%" />,
      value: log?.HEALTH_LOG_PROTEIN?.[0]?.log_numeric || "---",
      measure: '%',
      scale:
        metricFormatAthlete(
          11,
          log?.HEALTH_LOG_PROTEIN?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 12,
      name: `BMR`,
      nameComplete: "BMR",
      image: <BmrImage width="100%" />,
      value: log?.HEALTH_LOG_BMR?.[0]?.log_numeric || "---",
      measure: 'KCal',
      scale:
        metricFormatAthlete(
          12,
          log?.HEALTH_LOG_BMR?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
    {
      id: 13,
      name: `Edad Corporal`,
      nameComplete: "Edad Corporal",
      image: <EdadCorporalImage width="100%" />,
      value: log?.HEALTH_LOG_HEALTH_AGE?.[0]?.log_numeric || "---",
      measure: 'años',
      scale:
        metricFormatAthlete(
          13,
          log?.HEALTH_LOG_HEALTH_AGE?.[0]?.log_numeric || null,
          info
        ) || "---",
    },
  ];

  return (
    <div className="d-flex flex-column col-3 px-2 h-100 w-100">
      <div className="d-flex justify-content-start">
        <span className="label-step">
          <strong>5. Información corporal</strong>
        </span>
      </div>
      <div className="pt-2 h-100">
        <div
          className="step2-card input_info_athlete p-2 w-100 "
          style={{ maxHeight: "94%" }}
        >
          {optionLogs && optionLogs.length > 0 ? (
            <PerfectScrollbar className=" d-flex py-2  px-3 flex-column">
              {optionLogs.map((elemento) =>
                elemento ? (
                  <div
                    className="d-flex py-2 px-4 align-items-center col-12 step5-item"
                    style={{
                      borderBottom: "1px solid var(--elevvaTextTitle)",
                    }}
                  >
                    <div className="col d-flex" style={{ textAlign: "left" }}>
                      <span>{elemento.image}</span>
                    </div>
                    <div className="col" style={{ textAlign: "left" }}>
                      <span className="">{elemento.name}</span>
                    </div>
                    <div className="col" style={{ textAlign: "center" }}>
                      <span style={{ color: ["normal","saludable", "---"].includes(elemento.scale.toLowerCase()) ? 'rgb(157, 172, 189)' : '#5d97cb'}} >{elemento.scale}</span>
                    </div>
                    <div className="col" style={{ textAlign: "right" }}>
                      <span>
                        {elemento?.value && typeof elemento?.value == "number"
                          ? Number(elemento?.value)?.toFixed(2) + (elemento?.measure ? " " + elemento?.measure : '')
                          : "---"}
                      </span>
                    </div>
                  </div>
                ) : null
              )}
            </PerfectScrollbar>
          ) : (
            <div className="d-flex mx-1 my-2" style={{ alignItems: "center" }}>
              <span
                className=" text-objective-jus"
                style={{ fontSize: "calc(.4rem + .3vw)" }}
              >
                No tiene objetivos asignados
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step5;
